import { render, staticRenderFns } from "./file-manager.vue?vue&type=template&id=3f65ccf1&"
import script from "./file-manager.vue?vue&type=script&lang=js&"
export * from "./file-manager.vue?vue&type=script&lang=js&"
import style0 from "./file-manager.vue?vue&type=style&index=0&id=3f65ccf1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports